import { render } from "./policy-quote.vue?vue&type=template&id=e0da88ca&scoped=true"
import script from "./policy-quote.vue?vue&type=script&lang=js"
export * from "./policy-quote.vue?vue&type=script&lang=js"

import "./policy-quote.vue?vue&type=style&index=0&id=e0da88ca&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0da88ca"]])

export default __exports__